import { render } from "./ExperienceText.vue?vue&type=template&id=2a63ed41&scoped=true"
import script from "./ExperienceText.vue?vue&type=script&lang=js"
export * from "./ExperienceText.vue?vue&type=script&lang=js"

import "./ExperienceText.vue?vue&type=style&index=0&id=2a63ed41&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a63ed41"]])

export default __exports__